import React, { useEffect, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import categoryAPI from "../../api/categoryApi";
import CategoryCard from "../categories/Card";

function ListPage() {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true);

    try {
      const res = await categoryAPI.listing();

      if (res.code === 200) {
        const { items, totalCount } = res.data;

        setItems(items);
        setTotalCount(totalCount);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrump title="Category" />

      <section className="s-term-user flat-spacing-25">
        <div className="container">
          <div className="blog-count text-left mb-4">
            Total: <b>{totalCount}</b> categories
          </div>

          {items && items.length > 0 && (
            <div className="row">
              {items.map((item, index) => (
                <div className="col-md-2" key={index}>
                  <CategoryCard item={item} />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default ListPage;
